import React, { useState } from 'react';

const formatDate = (ts) => {
  if (!ts) return '—';
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
};

const VersionHistory = ({ versions = [], currentVersion, onRestore }) => {
  const [expanded, setExpanded] = useState(false);
  const [previewIdx, setPreviewIdx] = useState(null);

  if (versions.length === 0) return null;

  const sorted = [...versions].sort((a, b) => b.version - a.version);

  return (
    <div className="bg-gray-800 border border-gray-700 rounded-lg">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full px-4 py-3 flex justify-between items-center text-left"
      >
        <span className="text-sm font-medium text-gray-300">
          Version History ({versions.length} previous)
        </span>
        <span className="text-gray-500 text-xs">{expanded ? '▲' : '▼'}</span>
      </button>

      {expanded && (
        <div className="border-t border-gray-700 divide-y divide-gray-700">
          {sorted.map((v, idx) => (
            <div key={idx} className="px-4 py-3">
              <div className="flex justify-between items-center mb-1">
                <div className="flex items-center gap-2">
                  <span className="text-xs font-medium text-gray-400">v{v.version}</span>
                  <span className="text-xs text-gray-500">{formatDate(v.createdAt)}</span>
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={() => setPreviewIdx(previewIdx === idx ? null : idx)}
                    className="text-xs text-blue-400 hover:text-blue-300"
                  >
                    {previewIdx === idx ? 'Hide' : 'Preview'}
                  </button>
                  <button
                    onClick={() => onRestore(v.body, v.version)}
                    className="text-xs text-yellow-400 hover:text-yellow-300"
                  >
                    Restore
                  </button>
                </div>
              </div>
              {v.feedback && (
                <p className="text-xs text-gray-500 italic">Feedback: {v.feedback}</p>
              )}
              {previewIdx === idx && (
                <div className="mt-2 bg-gray-900 rounded p-3 max-h-48 overflow-y-auto">
                  <pre className="text-xs text-gray-300 whitespace-pre-wrap font-sans">{v.body}</pre>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VersionHistory;
